import {
  accountDetailsRequestHandler,
  addAccountRequestHandler,
  deleteAccountRequestHandler,
} from '../../Utilities/ApiRequestHandler';

export async function deleteAccount(accountId: string, sessionId: string) {
  if (!sessionId || sessionId === '' || !accountId || accountId === '') return;
  return await deleteAccountRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/twilio-whatsapp/${accountId}`,
    {
      method: 'DELETE',
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_remove_whatsapp',
  );
}

export async function addNewTwilioWhatsappAccount(
  sessionId: string,
  accountPayload: addNewTwilioWhatsappAccountPayload,
) {
  if (!sessionId || sessionId === '') return;
  const requestOptions = {
    body: JSON.stringify(accountPayload),
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      'x-session-id': sessionId,
    },
    method: 'POST',
  };

  return await addAccountRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/twilio-whatsapp`,
    requestOptions,
  );
}

export async function getAccountDetails(sessionId: string, connectionId: string) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  return await accountDetailsRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/twilio-whatsapp/${connectionId}`,
    {
      headers: {
        'x-session-id': sessionId,
      },
    },
    'failed_to_load_whatsapp',
  );
}

export async function updateMenuReplyConfiguration(
  sessionId: string,
  connectionId: string,
  menuConfiguration: string,
  hasTwilioWhatsAppTemplate?: boolean,
  messagingServiceSid = '',
) {
  if (!sessionId || sessionId === '' || !connectionId || connectionId === '') return;
  return await accountDetailsRequestHandler(
    `${process.env.REACT_APP_API_PATH}/connections/twilio-whatsapp/${connectionId}`,
    {
      headers: {
        'x-session-id': sessionId,
      },
      method: 'POST',
      body: JSON.stringify({
        menuConfiguration,
        hasTwilioWhatsAppTemplate,
        messagingServiceSid,
      }),
    },
    'menu_config_update_failure',
  );
}
